import React from "react";
import { Controller, useFormContext } from "react-hook-form";
import { FormControl, FormControlLabel, RadioGroup as MuiRadioGroup, Radio } from "@mui/material";

interface RadioOption {
  value: string;
  label: string;
}

interface RHFRadioGroupProps {
  name?: string;
  options?: RadioOption[];
  row?: boolean;
  isCircularRadio?: boolean;
  className?: string;
  [key: string]: any;
}

export const RHFRadioGroup = React.memo(({ 
  name = "", 
  options = [], 
  row = false, 
  isCircularRadio = false, 
  className, 
  ...other 
}: RHFRadioGroupProps) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <div className="radio-group">
          <FormControl error={!!error}>
            <MuiRadioGroup
              {...field}
              row={row}
              {...other}
              className={className}
              onChange={(event, value) => {
                field.onChange(event);
                other?.onChange?.(event, value);
              }}
            >
              {options.map((option: RadioOption) => (
                <FormControlLabel
                  key={option.value}
                  value={option.value}
                  control={
                    <Radio
                      sx={{
                        ...(isCircularRadio && {
                          '&.Mui-checked': {
                            color: 'primary.main',
                          },
                          '& .MuiSvgIcon-root': {
                            fontSize: 20,
                          },
                        }),
                      }}
                    />
                  }
                  label={option.label}
                />
              ))}
            </MuiRadioGroup>
            {error && (
              <div style={{ color: 'red', fontSize: '12px', marginTop: '4px' }}>
                {error.message}
              </div>
            )}
          </FormControl>
        </div>
      )}
    />
  );
});
